import * as React from 'react';

var Logo = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "header__logo", "data-testid": "backToLanding_button" }, children));
};
var Logo$1 = React.memo(Logo);

export { Logo$1 as L };
//# sourceMappingURL=Logo-a30b3a4c.js.map
